
/**
* Block Ghost member attribution ("ghost-history" in localStorage) until Cookiebot consent.
* Prevents endless reload by persisting a one-time flag in sessionStorage.
*/
(function () {
    const KEY = 'ghost-history';
    const RELOAD_FLAG = 'z2_cb_attrib_reloaded_v1';

    const originalSetItem = Storage.prototype.setItem;
    const originalRemoveItem = Storage.prototype.removeItem;

    let unlocked = false;

    function hasConsent() {
        // Usually statistics; use marketing as well if you classify it that way
        return !!(window.Cookiebot && (Cookiebot.consent.statistics || Cookiebot.consent.marketing));
    }

    function lockWrites() {
        Storage.prototype.setItem = function(k, v) {
            if (!unlocked && k === KEY) return;
            return originalSetItem.call(this, k, v);
        };
        Storage.prototype.removeItem = function(k) {
            if (!unlocked && k === KEY) return;
            return originalRemoveItem.call(this, k);
        };

        // Ensure nothing remains from earlier visits
        try { originalRemoveItem.call(window.localStorage, KEY); } catch (e) {}
    }

    function unlockWritesAndMaybeReload() {
        if (unlocked) return;
        unlocked = true;

        Storage.prototype.setItem = originalSetItem;
        Storage.prototype.removeItem = originalRemoveItem;

        // Reload at most once per session (prevents loops)
        try {
            const alreadyReloaded = sessionStorage.getItem(RELOAD_FLAG) === '1';
            if (!alreadyReloaded) {
                sessionStorage.setItem(RELOAD_FLAG, '1');
                window.location.reload();
            }
        } catch (e) {
            // If sessionStorage is blocked for some reason, DO NOT reload (avoid loops)
        }
    }

    // Lock immediately (must run before Ghost scripts)
    lockWrites();

    // If user already has consent (returning visitor), unlock without waiting for callbacks:
    // (Cookiebot may set Cookiebot object after load; callbacks below handle that case)
    if (hasConsent()) {
        // IMPORTANT: do NOT reload here – callbacks will handle controlled reload
        unlocked = true;
        Storage.prototype.setItem = originalSetItem;
        Storage.prototype.removeItem = originalRemoveItem;
    }

    // Cookiebot global callbacks
    window.CookiebotCallback_OnLoad = function () {
        if (hasConsent()) unlockWritesAndMaybeReload();
    };

    window.CookiebotCallback_OnAccept = function () {
        if (hasConsent()) unlockWritesAndMaybeReload();
    };
})();


